// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodepenCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/CodepenCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var CodepenCircleOutlined = function CodepenCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodepenCircleOutlinedSvg
  }));
};

CodepenCircleOutlined.displayName = 'CodepenCircleOutlined';
export default React.forwardRef(CodepenCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CodepenCircleOutlined.js
// module id = 827
// module chunks = 0